import apiClient from "./apiClient";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const submitTicket = (data: any) => {
  return apiClient
    .post(`${BASE_URL}/ticket/contact-us/`, data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      throw err;
    });
};
